import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';
import { logPageView } from '../services/api';

const HomePage = () => {
  const [url, setUrl] = useState('');
  const navigate = useNavigate();

  useEffect(() => { logPageView('/'); }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedUrl = url.trim();
    console.log('[HomePage] Form submitted with URL:', trimmedUrl);
    if (trimmedUrl) {
      console.log('[HomePage] Navigating to progress page');
      navigate('/progress', { state: { url: trimmedUrl } });
    }
  };

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen flex flex-col w-full overflow-x-hidden">
      <Header />

      {/* Main Content */}
      <main className="flex-grow flex flex-col items-center justify-center relative px-4 py-12 md:py-20 w-full overflow-x-hidden">
        {/* Ambient Background Glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[min(600px,100vw)] h-[min(600px,100vh)] bg-primary/20 rounded-full blur-[120px] -z-10 pointer-events-none"></div>

        <div className="flex flex-col items-center w-full max-w-[800px] gap-8 md:gap-12">
          {/* Hero Section */}
          <div className="flex flex-col items-center text-center gap-6">
            {/* Logo */}
            <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden shadow-2xl shadow-primary/20 bg-surface-dark border border-surface-border flex items-center justify-center mb-4">
              <img src="/logo.png" alt="PRL" className="w-full h-full object-contain p-4" />
            </div>

            <div className="flex flex-col gap-3 max-w-[600px]">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60">
                Konwerter MP3
              </h1>
              <p className="text-slate-500 dark:text-slate-400 text-lg md:text-xl font-normal leading-relaxed">
                Wklej link z YouTube, aby przekonwertować utwór
                na format MP3 i wykorzystać w grze.
              </p>
            </div>
          </div>

          {/* Input Form */}
          <div className="w-full max-w-[560px] relative group z-10">
            <div className="absolute -inset-1 bg-gradient-to-r from-primary to-purple-600 rounded-xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
            <form
              className="relative flex flex-col sm:flex-row w-full bg-white dark:bg-surface-dark p-2 rounded-xl border border-gray-200 dark:border-surface-border shadow-xl"
              onSubmit={handleSubmit}
            >
              <div className="flex-1 flex items-center px-3 gap-2">
                <span className="material-symbols-outlined text-slate-400">link</span>
                <input
                  className="w-full bg-transparent border-none focus:ring-0 text-slate-900 dark:text-white placeholder-slate-400 dark:placeholder-slate-500 text-base py-3"
                  placeholder="https://youtube.com/watch?v=..."
                  type="text"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  required
                />
              </div>
              <button
                className="mt-2 sm:mt-0 sm:ml-2 bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-lg transition-all duration-200 flex items-center justify-center gap-2 shadow-lg shadow-primary/30 active:scale-95 whitespace-nowrap"
                type="submit"
              >
                <span>Zatwierdź</span>
                <span className="material-symbols-outlined text-sm font-bold">arrow_forward</span>
              </button>
            </form>

            {/* Helper text */}
            <div className="mt-3 flex items-center justify-center gap-4 text-xs font-medium text-slate-500 dark:text-slate-500">
              <span className="flex items-center gap-1">
                <span className="material-symbols-outlined text-[14px]">check_circle</span>
                Obsługuje YouTube
              </span>
              <span className="flex items-center gap-1">
                <span className="material-symbols-outlined text-[14px]">bolt</span>
                Szybka konwersja
              </span>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
